import { render, staticRenderFns } from "./CarrinhoPrazosDisponiveisGerais.vue?vue&type=template&id=00f2d1ad&scoped=true"
import script from "./CarrinhoPrazosDisponiveisGerais.vue?vue&type=script&lang=js"
export * from "./CarrinhoPrazosDisponiveisGerais.vue?vue&type=script&lang=js"
import style0 from "./CarrinhoPrazosDisponiveisGerais.vue?vue&type=style&index=0&id=00f2d1ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f2d1ad",
  null
  
)

export default component.exports